import { formatInstant, FrequentTimeZones } from '@airreading/common';
import { Temporal } from 'temporal-polyfill';

import { pluralize } from '@/lib/string-utils.js';

// Helper functions to format the teacher pool summary

export function viewedTeacherPoolNote(matchingTeachersCount: number): string {
  const teacherLabel = pluralize(matchingTeachersCount, 'teacher', 'teachers');
  return `${matchingTeachersCount} active ${teacherLabel}. Saved filters are read-only. All active pools apply during auto-assignment.`;
}

export function teacherPoolSummary(activePoolCount: number, distinctReservedTeacherCount: number): string {
  const poolLabel = pluralize(activePoolCount, 'pool', 'pools');
  const teacherLabel = pluralize(distinctReservedTeacherCount, 'teacher', 'teachers');
  return `${activePoolCount} active ${poolLabel} · ${distinctReservedTeacherCount} distinct reserved ${teacherLabel} (each teacher is counted once across all active pools)`;
}

export function teacherPoolUpdatedLabel(updatedAt: Temporal.Instant | string): string {
  const instant = typeof updatedAt === 'string' ? Temporal.Instant.from(updatedAt) : updatedAt;
  const { formattedDateWithoutYear, formattedTime } = formatInstant(instant, FrequentTimeZones.UsCentral);
  const time = formattedTime.replace(/\b(am|pm)\b/i, (meridiem) => meridiem.toUpperCase());
  return `Updated ${formattedDateWithoutYear}, ${time} CT`;
}
